<script setup>
import { ref } from 'vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

defineProps({
  title: { type: String, default: '' },
  ticketCount: { type: Number, default: 0 },
  hasAppliedFilters: { type: Boolean, default: false },
  isListLoading: { type: Boolean, default: false },
});

const emit = defineEmits(['search', 'filtersModal', 'resetFilters', 'create']);

const searchQuery = ref('');

const onSearch = () => {
  emit('search', searchQuery.value);
};
</script>

<template>
  <div
    class="relative flex flex-col border-b border-n-weak"
    :class="{ 'border-n-strong': hasAppliedFilters }"
  >
    <div class="flex items-center justify-between gap-2 px-3 h-12">
      <div class="flex items-center min-w-0">
        <h1
          class="text-base font-medium truncate text-n-slate-12"
          :title="title"
        >
          {{ title }}
        </h1>
        <span
          v-if="hasAppliedFilters && ticketCount > 0 && !isListLoading"
          class="px-2 py-1 my-0.5 mx-1 rounded-md bg-n-slate-3 text-xxs text-n-slate-12 shrink-0"
        >
          {{ ticketCount }}
        </span>
      </div>
      <div class="flex items-center gap-1 shrink-0">
        <NextButton
          v-if="hasAppliedFilters"
          v-tooltip.top-end="$t('FILTER.CLEAR_BUTTON_LABEL')"
          icon="i-lucide-circle-x"
          ruby
          faded
          xs
          @click="emit('resetFilters')"
        />
        <div class="relative z-[1100]">
          <NextButton
            id="toggleTicketFilterButton"
            v-tooltip.right="$t('TICKETS.FILTER.TOOLTIP_LABEL')"
            icon="i-lucide-list-filter"
            slate
            faded
            xs
            @click="emit('filtersModal')"
          />
          <div
            id="ticketFilterTeleportTarget"
            class="absolute z-[1100] mt-2 ltr:left-full ltr:ml-2 rtl:right-full rtl:mr-2"
          />
        </div>
        <NextButton
          icon="i-lucide-plus"
          slate
          xs
          faded
          @click="emit('create')"
        />
      </div>
    </div>

    <div class="px-3 pb-3">
      <div class="relative">
        <input
          v-model="searchQuery"
          type="text"
          :placeholder="$t('TICKETS.SEARCH.PLACEHOLDER')"
          class="w-full pl-8 pr-3 py-1.5 text-sm rounded-lg bg-n-solid-3 border border-n-weak text-n-slate-12 placeholder-n-slate-10 focus:outline-none focus:ring-1 focus:ring-n-brand"
          @keyup.enter="onSearch"
        />
        <span
          class="absolute left-2.5 top-1/2 -translate-y-1/2 i-lucide-search text-n-slate-10 w-3.5 h-3.5"
        />
      </div>
    </div>

  </div>
</template>
